/**
 * @singleton
 */
class Translate {
    constructor(translations, locale, options) {
        this.translations = translations || {};
        this.locale       = locale;
        this.options      = Object.assign({
            //defaults?
            /*
            defaultLocale
             */
        }, options);
    }

    addDictionary(locale, dictionary) {
        this.translations[locale] = dictionary;
    }

    /*
    //TODO: not needed rioght now because fallback is directly in the code
    setFallbackLocale(locale) {
        this.options.fallbackLocale = locale;
    }*/

    setLocale(locale) {
        this.locale = locale;
        //TODO: emit
    }

    $replace() {
        let args = arguments;
        let i    = 0;
        //TODO: add positioned strings etc.
        return args[0].replace(/%s/g, function (match, pos) {
            i++;
            return args[i] !== undefined ? args[i] : match;
        });
    }

    __(text, ...translations) {
        if (!this.locale || !this.translations || !this.translations[this.locale] || !this.translations[this.locale][text]) {
            return this.$replace(text, ...translations);
        }
        return this.$replace(this.translations[this.locale][text], ...translations);
    }
}

export default new Translate();




// WEBPACK FOOTER //
// ./src/core/translate.js